export * from "./core/index.js";
export * from "./react/index.js";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/index.js
// module id = 866
// module chunks = 4